import { Controller } from 'stimulus';

const TIMEOUT = 5000;

class AlertController extends Controller {
  connect() {
    setTimeout(() => {
      $(this.element).fadeOut(() => {
        $(this.element).remove();
      });
    }, TIMEOUT);
  }
}

AlertController.targets = [];

export default AlertController;
